module.exports = __webpack_public_path__ + "assets/img/coast-carbon.f5c6c957.png";